import http, { getBase } from '../http'

const API_URL = 'company-signatures'

class SignaturesAPI {
  async index(companyId) {
    return await http(`${API_URL}/${companyId}`)
  }

  async store(companyId, { signer_name, signer_document, signer_license, signer_position, image }) {
    const fd = new FormData()
    // El rol lo fija el backend a 'gerente' (única firma electrónica = Responsable SG-SST).
    fd.append('signer_name', signer_name)
    if (signer_document) fd.append('signer_document', signer_document)
    if (signer_license) fd.append('signer_license', signer_license)
    if (signer_position) fd.append('signer_position', signer_position)
    fd.append('image', image)
    const res = await fetch(`${getBase()}${API_URL}/${companyId}`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
    })
    return res.json()
  }

  async destroy(id) {
    return await http(`${API_URL}/${id}`, 'DELETE')
  }
}

export default new SignaturesAPI()
